import { Button, Modal, Typography } from 'antd';
import React from 'react';

interface IComponentProps {
  isVisible: boolean;
  title: string;
  mainText: string;
  onCancel: () => void;
  onSubmit: () => void;
  submitText?: string;
  cancelText?: string;
  loading: boolean;
}

export const ConfirmationModal: React.FC<IComponentProps> = ({
  isVisible,
  submitText = 'Confirm',
  cancelText = 'Cancel',
  title,
  mainText,
  onCancel,
  onSubmit,
  loading,
}) => {
  return (
    <Modal width={340} open={isVisible} footer={null} onCancel={onCancel} title={<Typography.Title level={5} className="mb-4 t-align-c">{title}</Typography.Title>} closeIcon={null}>
      <div className="mb-4 t-align-c">{mainText}</div>
      <div className="flex flex__column flex-align-center">
        <Button className="popup__btn mb-4" disabled={loading} loading={loading} title={submitText} onClick={onSubmit}>
          {submitText}
        </Button>
        <Button
          className="popup__btn"
          type="primary"
          disabled={loading}
          loading={loading}
          title={cancelText}
          onClick={onCancel}
        >
          {cancelText}
        </Button>
      </div>
    </Modal>
  );
};
